import { useContext, useState } from "react";
import { ThemeContext, type ThemeState } from "../lib/themes/store";
import type { ThemeMode } from "../lib/themes/types";

interface UsePreferredThemeOptions {
	defaultMode?: ThemeMode;
}

export function usePreferredTheme(
	opts?: UsePreferredThemeOptions,
): [ThemeMode | null, (mode: ThemeMode) => void] {
	const [currentMode, setCurrentMode] = useState<ThemeMode>((): ThemeMode => {
		if (opts?.defaultMode) {
			return opts.defaultMode;
		}

		return "dark";
		// return window.matchMedia("(prefers-color-scheme: dark)").matches
		//   ? "dark"
		//   : "light";
	});

	// useEffect(() => {
	//   const changeMode = (e: MediaQueryListEvent): void => {
	//     setCurrentMode(e.matches ? "dark" : "light");
	//   };

	//   const mql = window.matchMedia("(prefers-color-scheme: dark)");

	//   mql.addEventListener("change", changeMode);

	//   return () => {
	//     mql.removeEventListener("change", changeMode);
	//   };
	// }, []);

	return [currentMode, setCurrentMode];
}

export const useTheme = (): ThemeState => useContext(ThemeContext);
